import 'mobx-react-lite/optimizeForReactDom';
import React from 'react';
import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';

import { createRoot } from 'react-dom/client';

import * as Sentry from '@sentry/react';

Sentry.init({
  dsn:
    'https://03821715a2edf488d3904e4b54529bb7@o4506589734567936.ingest.us.sentry.io/4509452301565952',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

console.log('JUSS', React.version);
const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
